import bus from 'public/utils/bus'
import { setGenericTreeData, setPreloadDeptTree } from 'public/components/query-table/utils'

bus.$on('preload-dept-tree', setPreloadDeptTree)

bus.$once('APP_LOADED', setGenericTreeData)



// WEBPACK FOOTER //
// ./src/public/components/query-table/module/bus.js